import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 17,
	height: 17,
	fill: "currentColor",
	viewBox: "0 0 17 17",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M16.375 2.21125L14.7887 0.625L8.5 6.91375L2.21125 0.625L0.625 2.21125L6.91375 8.5L0.625 14.7887L2.21125 16.375L8.5 10.0863L14.7887 16.375L16.375 14.7887L10.0863 8.5L16.375 2.21125Z" }));
export default SvgClose;
